/**
 * shadcn-style <Input> — minimal hand-roll (Phase 2, #mc-phase2).
 *
 * The codebase had no form primitives before Phase 2 (only Button +
 * Toast). Rather than pull in a Radix package for a plain text input,
 * we ship the canonical shadcn className on a forwardRef'd <input>.
 * Same visual vocabulary as Button (`rounded-md border …
 * focus-visible:ring-2 …`). If a richer input need ever lands, swap
 * this for the upstream shadcn component.
 */

import * as React from "react";
import { cn } from "@/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => (
    <input
      type={type}
      ref={ref}
      className={cn(
        "flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background",
        "placeholder:text-muted-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";

export { Input };
